/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, getNumTypeAttr, getStrTypeAttr, nextAll, prevAll, removeAttrs, setCss, setHtml } from '../../dom-utils';
import { warn } from '../../mixins';
import { type, validComps } from '../../utils';
import PREFIX from '../prefix';
var Steps = /** @class */ (function () {
    function Steps() {
        this.VERSION = '1.0';
        this.COMPONENTS = $el('r-steps', { all: true });
        this._create(this.COMPONENTS);
    }
    Steps.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'steps');
        var _a = Steps.prototype, _setCurrentStep = _a._setCurrentStep, _setStatus = _a._setStatus, _setStatusIcon = _a._setStatusIcon;
        var _current = target.dataset['current'];
        var StepsTitle = target.querySelector("." + PREFIX.steps + "-title");
        var StepsContent = target.querySelector("." + PREFIX.steps + "-content");
        var StepsStep = target.querySelectorAll('r-step');
        var setTitleOrContent = function (elem, val) {
            if (val && !type.isStr(val))
                return;
            setHtml(elem, val);
        };
        return {
            get current() {
                return Number(target.dataset['current']);
            },
            set current(newVal) {
                if (!type.isNum(newVal))
                    return;
                _setCurrentStep(target, newVal, target.dataset['status']);
            },
            get title() {
                return setHtml(StepsTitle);
            },
            set title(newVal) {
                setTitleOrContent(StepsTitle, newVal);
            },
            get content() {
                return setHtml(StepsContent);
            },
            set content(newVal) {
                setTitleOrContent(StepsContent, newVal);
            },
            get status() {
                return target.dataset['status'];
            },
            set status(newVal) {
                if (newVal && !type.isStr(newVal))
                    return;
                var currentStep = target.querySelector("r-step[data-index=\"" + _current + "\"]");
                _setStatus(target, currentStep, newVal);
            },
            get itemStatus() {
                return [];
            },
            set itemStatus(newVal) {
                if (newVal && !type.isArr(newVal))
                    return;
                var changeStatus = function (elem, status) {
                    elem.setAttribute('status', status);
                    _setStatusIcon(status, elem);
                };
                if (newVal.length == 1) {
                    var step = StepsStep[0];
                    changeStatus(step, newVal[0]);
                    return;
                }
                StepsStep.forEach(function (step, idx) {
                    return newVal[idx] ? changeStatus(step, newVal[idx]) : '';
                });
            }
        };
    };
    Steps.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), current = _a.current, status = _a.status, direction = _a.direction;
            var StepsStepItem = node.querySelectorAll('r-step');
            _this._setDirection(node, direction);
            _this._setStepChildren(StepsStepItem);
            _this._setCurrentStep(node, current, status);
            removeAttrs(node, ['current', 'status']);
        });
    };
    Steps.prototype._setDirection = function (node, direction) {
        node.setAttribute('direction', "" + direction);
    };
    Steps.prototype._setStepChildren = function (stepItem) {
        var _this = this;
        stepItem.forEach(function (step, idx) {
            // @ts-ignore
            step.dataset['index'] = "" + idx;
            _this._setStatusFlag(step);
            var _a = _this._attrs(step), icon = _a.icon, title = _a.title, content = _a.content;
            var stepsText = idx + 1;
            var template = "\n             <div class=\"" + PREFIX.steps + "-tail\"><i></i></div>\n             <div class=\"" + PREFIX.steps + "-head\">\n                <div class=\"" + PREFIX.steps + "-head-inner\">\n                   <span id=\"stepsIcon\"></span>\n                   <span id=\"stepsText\">" + stepsText + "</span>\n                </div>\n             </div>\n             <div class=\"" + PREFIX.steps + "-main\">\n                <div class=\"" + PREFIX.steps + "-title\">" + title + "</div>\n                <div class=\"" + PREFIX.steps + "-content\">" + content + "</div>\n             </div>\n            ";
            setHtml(step, template);
            _this._setCustomIcon(step, icon);
            removeAttrs(step, ['title', 'content', 'icon']);
        });
    };
    Steps.prototype._setStatusFlag = function (step) {
        var status = step.getAttribute('status');
        // 如果用户在步骤项设置了status则为该项打上标记，避免被自动设置的默认状态覆盖
        if (status) {
            // @ts-ignore
            step.dataset['specifiesStatus'] = status;
        }
    };
    Steps.prototype._setCurrentStep = function (node, current, status) {
        var len = node.childElementCount - 1;
        // 防止溢出边界
        if (current > len) {
            warn("The currently active step item you set does not exist in the <r-steps>. --> \"" + current + "\"");
            console.error(node);
            current = len;
        }
        // @ts-ignore
        node.dataset['current'] = current;
        var _setStatus = Steps.prototype._setStatus;
        var currentStep = node.querySelector("r-step[data-index=\"" + current + "\"]");
        _setStatus(node, currentStep, status);
    };
    Steps.prototype._setStatus = function (node, currentStep, status) {
        // @ts-ignore
        node.dataset['status'] = status;
        var _a = Steps.prototype, _setStatusIcon = _a._setStatusIcon, _setPrevAndNextStatus = _a._setPrevAndNextStatus, _setNextError = _a._setNextError;
        // @ts-ignore
        var isAutoStatus = currentStep.dataset['autoStatus'];
        var selfStatus = currentStep.getAttribute('status');
        // 1.如果步骤项设置了status则优先使用该状态，不包括打上autoStatus的标记项。
        // 2.如果步骤项父容器指定了某项步骤项为活跃状态，并且指定了 status 则使用该状态。
        if (selfStatus && isAutoStatus !== '') {
            currentStep.setAttribute('status', selfStatus);
            _setStatusIcon(selfStatus, currentStep);
        }
        else {
            currentStep.setAttribute('status', status);
            _setStatusIcon(status, currentStep);
        }
        _setPrevAndNextStatus('prev', currentStep, _setStatusIcon);
        _setPrevAndNextStatus('next', currentStep, _setStatusIcon);
        _setNextError(node);
    };
    Steps.prototype._setPrevAndNextStatus = function (type, currentStep, setStatusIcon) {
        // @ts-ignore
        var func = type === 'prev' ? prevAll : nextAll;
        var defaultStatus = type === 'prev' ? 'finish' : 'wait';
        func(currentStep).forEach(function (step) {
            // @ts-ignore
            var hasSetStatus = step.dataset['specifiesStatus'];
            // 当前步骤项位置的其他节点如果没有提示设置status，则默认设置为 finish / wait，并打上标记
            // 如果其中有某个设置了则略过
            if (!hasSetStatus) {
                // @ts-ignore
                step.dataset['autoStatus'] = '';
                step.setAttribute('status', defaultStatus);
                setStatusIcon(defaultStatus, step);
            }
            else {
                setStatusIcon(hasSetStatus, step);
            }
        });
    };
    Steps.prototype._setStatusIcon = function (status, step) {
        // @ts-ignore
        var isUseCustomIcon = step.dataset['useIcon'] === 'true';
        // 如果使用了自定义图标则略过
        if (isUseCustomIcon)
            return;
        var StepsIcon = step.querySelector('#stepsIcon');
        var StepsText = StepsIcon.nextElementSibling;
        // 步骤项状态不为finish或error则显示步骤数字、隐藏图标容器，反之。
        if (status !== 'finish' && status !== 'error') {
            setCss(StepsIcon, 'display', 'none');
            setCss(StepsText, 'display', '');
            return;
        }
        setCss(StepsIcon, 'display', '');
        setCss(StepsText, 'display', 'none');
        var iconType = '';
        if (status === 'finish') {
            iconType = 'ios-checkmark';
        }
        if (status === 'error') {
            iconType = 'ios-close';
        }
        StepsIcon.className = PREFIX.steps + "-icon " + PREFIX.icon + " " + PREFIX.icon + "-" + iconType;
    };
    Steps.prototype._setCustomIcon = function (step, icon) {
        if (!icon)
            return;
        // @ts-ignore
        step.dataset['useIcon'] = 'true';
        step.classList.add(PREFIX.steps + "-custom");
        var StepsIcon = step.querySelector('#stepsIcon');
        StepsIcon.classList.add("" + PREFIX.icon);
        StepsIcon.classList.add(PREFIX.icon + "-" + icon);
        setCss(StepsIcon.nextElementSibling, 'display', 'none');
    };
    Steps.prototype._setNextError = function (node) {
        var StepsStep = node.querySelectorAll('r-step');
        StepsStep.forEach(function (step, idx) {
            if (step.getAttribute('status') === 'error' && idx !== 0) {
                var prevStep = StepsStep[idx - 1];
                if (prevStep.getAttribute('status') === 'error') {
                    prevStep.classList.add(PREFIX.steps + "-next-error");
                }
                else {
                    prevStep.classList.remove(PREFIX.steps + "-next-error");
                }
            }
        });
    };
    Steps.prototype._attrs = function (node) {
        return {
            current: getNumTypeAttr(node, 'current', 0),
            icon: getStrTypeAttr(node, 'icon', ''),
            title: getStrTypeAttr(node, 'title', ''),
            status: getStrTypeAttr(node, 'status', 'process'),
            content: getStrTypeAttr(node, 'content', ''),
            direction: getStrTypeAttr(node, 'direction', 'horizontal')
        };
    };
    return Steps;
}());
export default Steps;
